const Group = () => (
  <>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M3.5 8A2.5 2.5 0 0 1 6 5.5h12A2.5 2.5 0 0 1 20.5 8v8a2.5 2.5 0 0 1-2.5 2.5H6A2.5 2.5 0 0 1 3.5 16zM6 6.5A1.5 1.5 0 0 0 4.5 8v8A1.5 1.5 0 0 0 6 17.5h12a1.5 1.5 0 0 0 1.5-1.5V8A1.5 1.5 0 0 0 18 6.5z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M7.5 14.5a.5.5 0 0 1 0-1h6a.5.5 0 0 1 0 1zm0-4a.5.5 0 0 1 0-1h9a.5.5 0 0 1 0 1z"
    />
  </>
)
export default Group
